import { createSlice } from '@reduxjs/toolkit';
import notificationApi from 'api/notificationApi';

import unitCourseApi from 'api/unitCourseApi';
import unitsApi from 'api/unitsApi';
import userApi from 'api/userApi';
// import { useUser } from 'hooks';
import { logout } from '../auth/index';

const initialState = {
  unitSelected: undefined,
  units: undefined,
  test: undefined,
  survey: undefined,
  error: undefined,
  lessonData: {},
  course: {
    name: '',
    _id: '',
  },
  queryUnit: undefined,
  countValue: undefined,
  adminvalue: undefined,
  instructorvalue: undefined,
  learnervalue: undefined,
  graphicalData: undefined,
  completeUnit: {},
  isUnitLoading: false,
};

export const unitsSlice = createSlice({
  name: 'units',
  initialState,
  reducers: {
    setUnit: (state, action) => {
      state.unitSelected = action.payload;
    },
    setLessonData: (state, action) => {
      state.lessonData = action.payload;
    },
    setQuery: (state, action) => {
      state.queryUnit = action.payload;
    },
    setCount: (state, action) => {
      state.countValue = action.payload;
    },
    setUnits: (state, action) => {
      state.units = action.payload;
    },
    setTest: (state, action) => {
      state.test = action.payload;
    },
    setSurvey: (state, action) => {
      state.survey = action.payload;
    },
    setUnitsError: (state, action) => {
      state.error = action.payload;
    },
    setCourse: (state, action) => {
      state.course = action.payload;
    },
    setAdmindata: (state, action) => {
      state.adminvalue = action.payload;
    },
    setInstructordata: (state, action) => {
      state.instructorvalue = action.payload;
    },
    setLearnerdata: (state, action) => {
      state.learnervalue = action.payload;
    },
    setGraphicalData: (state, action) => {
      state.graphicalData = action.payload;
    },
    setCompleteUnit: (state, action) => {
      state.completeUnit = action.payload;
    },
    setUnitLoading: (state, action) => {
      state.isUnitLoading = action.payload;
    },
  },
  extraReducers: {
    [logout]: (state) => initialState,
  },
});

// Actions
export const {
  setUnit,
  setAdmindata,
  setUnits,
  setTest,
  setSurvey,
  setCourse,
  setUnitsError,
  setQuery,
  setCount,
  setLessonData,
  setInstructordata,
  setLearnerdata,
  setGraphicalData,
  setCompleteUnit,
  setUnitLoading,
} = unitsSlice.actions;

// async action
export const fetchUnitAsync = (unitId) => async (dispatch) => {
  const unit = await unitCourseApi.getUnit({ id: unitId });
  return dispatch(setUnit(unit));
};

export const fetchAdminData = (param) => async (dispatch) => {
  const admindata = await userApi.getAdminSummary(param);
  return dispatch(setAdmindata(admindata));
};

export const fetchGraphicalInformation = (id) => async (dispatch) => {
  const alertData = await notificationApi.notificationalert(id);
  return dispatch(setGraphicalData(alertData));
};

export const fetchInstructorData = (param) => async (dispatch) => {
  const instructorData = await userApi.getInstructorSummary(param);

  return dispatch(setInstructordata(instructorData));
};

export const fetchLearnerData = (param) => async (dispatch) => {
  const learnerData = await userApi.getLearnerSummary(param);
  return dispatch(setLearnerdata(learnerData));
};

export const setUnitsErrorAsync = (error) => async (dispatch) =>
  dispatch(setUnitsError(error));

export const fetchUnitAdminAsync = (unitId) => async (dispatch) => {
  const unit = await unitsApi.getUnitById({ id: unitId });
  return dispatch(setUnit(unit));
};

export const fetchUnitsAsync = (courseId, centreValue) => async (dispatch) => {
  let param = {
    id: courseId,
  };
  if (centreValue?.centreId) {
    param.courseCentre = centreValue?.centreId;
  }
  if (centreValue?.reviewContent) {
    param.reviewContent = centreValue?.reviewContent;
  }
  const units = await unitCourseApi.getUnits(param);

  const course = {
    name: units?.name,
    _id: units?._id,
  };

  dispatch(setCourse(course));
  return dispatch(setUnits(units?.data));
};

export const refreshUnitAsync = (unitId) => async (dispatch) => {
  dispatch(setUnit(undefined));
  dispatch(setTest(undefined));
  dispatch(setSurvey(undefined));
  const unit = await unitCourseApi.getUnit({ id: unitId });
  return dispatch(setUnit(unit));
};

export const resetUnitAsync = (unitId, courseId, param) => async (dispatch) => {
  await unitCourseApi.resetUnit(unitId);
  await dispatch(fetchUnitAsync(unitId));
  dispatch(setTest(undefined));
  dispatch(setSurvey(undefined));
  return dispatch(fetchUnitsAsync(courseId, param));
};

export const completeUnitAsync =
  (data, unitId, courseId, param) => async (dispatch) => {
    const completeResponse = await unitCourseApi.setCompleteUnit(data, unitId);
    await dispatch(fetchUnitAsync(unitId));
    dispatch(setCompleteUnit(completeResponse));
    return dispatch(fetchUnitsAsync(courseId, param));
  };

export const fetchTestAsync = (unit, data) => async (dispatch) => {
  const test = await unitCourseApi.getDataStartTest(unit, data);
  return dispatch(setTest(test));
};

export const fetchTestAsync1 =
  (unitId, button, shuffle, previous) => async (dispatch) => {
    const test = await unitCourseApi.getDataStartTest({
      id: unitId,
      questionIndex: button,
      ...(shuffle && { shuffle: true }),
      ...(previous && { previous: true }),
    });
    return dispatch(setTest(test));
  };

export const submitTest =
  (params, body, unitId, courseId, current, param) => async (dispatch) => {
    // dispatch(setTest({ isLoading: true }));
    if (body?.userQuestion) {
      params.questionIndex = current;
      const test = await unitCourseApi.updateQuestion(params, body);
      dispatch(setTest(test));
      await dispatch(fetchUnitAsync(unitId));
      return dispatch(fetchUnitsAsync(courseId, param));
    } else {
      const test = await unitCourseApi.submitUnitQuestion(params, body);
      dispatch(setTest(test));
      await dispatch(fetchUnitAsync(unitId));
      return dispatch(fetchUnitsAsync(courseId, param));
    }
  };

export const fetchSurveyAsync = (unitId) => async (dispatch) => {
  const survey = await unitCourseApi.getDataStartSurvey({ id: unitId });
  return dispatch(setSurvey(survey));
};

export const submitSurvey =
  (params, body, unitId, courseId, param) => async (dispatch) => {
    dispatch(setSurvey({ isLoading: true }));
    const survey = await unitCourseApi.submitUnitSurvey(params, body);
    dispatch(setSurvey(survey));
    await dispatch(fetchUnitAsync(unitId));
    return dispatch(fetchUnitsAsync(courseId, param));
  };

export const resetUnit = () => (dispatch) => {
  dispatch(setTest(undefined));
};

export const adminGetUnit =
  (id, reset = true) =>
  async (dispatch) => {
    if (reset) {
      dispatch(setTest(undefined));
    }
    const test = await unitsApi.getUnitById({ id });
    return dispatch(setTest(test));
  };

export const getUnit = (state) => state.units.unitSelected;
export const getUnits = (state) => state.units.units;
export const getTest = (state) => state.units.test;
export const getSurvey = (state) => state.units.survey;
export const getCourse = (state) => state.units.course;
export const getUnitsError = (state) => state.units.error;
export const getUnitQuery = (state) => state.units.queryUnit;
export const getCountValue = (state) => state.units.countValue;
export const getLessonData = (state) =>
  state.units.lessonData.group
    ? state.units.lessonData
    : localStorage.getItem('groupdetails')
    ? JSON.parse(localStorage.getItem('groupdetails'))
    : '';
export const getAdminData = (state) => state.units.adminvalue;
export const getInstructorData = (state) => state.units.instructorvalue;
export const getLearnerData = (state) => state.units.learnervalue;
export const getGraphicalData = (state) => state.units.graphicalData;

export const getCompleteUnit = (state) => state.units.completeUnit;
export const getIsUnitLoading = (state) => state.units.isUnitLoading;

export default unitsSlice.reducer;
